export const checkBrowser = () => {
    const agent = window.navigator.userAgent.toLowerCase();

    switch (true) {
        case agent.indexOf("chrome") > -1:
            return true;
        case agent.indexOf("edg/") > -1:
            return true;
        default:
            alert("It is available for purchase in the Chrome browser.");
            window.location.href="https://www.google.co.kr/chrome/?brand=YTUH&gclid=Cj0KCQjwuLShBhC_ARIsAFod4fLbcRz19A26MuqT986_trQ7N0qqRhYkqIDPUBz1gGQNfMaOOvcl0e4aAkVZEALw_wcB&gclsrc=aw.ds";
            return false;
    }
}
